/* eslint-disable no-console */
import {Row, Col, Flex, Typography} from 'antd';
import React, {useState} from 'react';

import {ReactComponent as PlaybuttonIcon} from '../../assets/icons/PlaybuttonIcon.svg';
import ModalReactPlayer from '../../components/ReactPlayer/ModalReactPlayer';

const {Text} = Typography;

interface Video {
  subKey: string;
  subTitle: string;
  thumbnail: string;
  url: string;
}

interface ClipListProps {
  videos: Video[];
  videoPageTitle?: string;
  videoPageDescription?: string;
  showNoResultsMessage?: boolean; // new prop
}

const ClipList: React.FC<ClipListProps> = ({
  videos,
  videoPageTitle,
  videoPageDescription,
  showNoResultsMessage = false
}) => {
  const [video, setVideo] = useState<Video | null>(null);

  return (
    <>
      {(videoPageTitle ?? videoPageDescription) && (
        <Row gutter={[16, 16]} style={{margin: '16px 0px'}}>
          <Col span={24} style={{padding: '0px'}}>
            <Flex vertical gap={13}>
              {videoPageTitle && (
                <Flex className="videoPageTitle">{videoPageTitle}</Flex>
              )}
              {videoPageDescription && (
                <Flex className="videoPageDescription">
                  {videoPageDescription}
                </Flex>
              )}
            </Flex>
          </Col>
        </Row>
      )}
      <Row gutter={[16, 16]}>
        {videos && videos.length > 0
          ? videos.map((item) => (
              <Col span={12} key={item.subKey}>
                <Flex gap={10} vertical className="clipList">
                  <Flex
                    onClick={() => {
                      setVideo(item);
                    }}
                    className="clipImageWrapper"
                    style={{
                      cursor: 'pointer',
                      position: 'relative',
                      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.35) 100%),
                  url(${item?.thumbnail}),
                  linear-gradient(105deg, #435B37 0%, #719A5D 100%)`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  >
                    <div className="playButton">
                      <PlaybuttonIcon />
                    </div>
                    <div className="pilCompTitle">
                      <Text strong className="clipTitle">
                        {item.subTitle}
                      </Text>
                    </div>
                  </Flex>
                </Flex>
              </Col>
            ))
          : showNoResultsMessage && (
              <Col span={24} style={{height: '50px'}}>
                <Flex
                  style={{
                    justifyContent: 'start',
                    color: '#999',
                    fontWeight: '600',
                    fontStyle: 'italic',
                    fontSize: '17px'
                  }}
                >
                  No results found
                </Flex>
              </Col>
            )}
      </Row>

      {video && (
        <ModalReactPlayer
          video={video}
          onClose={() => {
            setVideo(null);
          }}
        />
      )}
    </>
  );
};

export default ClipList;
